import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type, record_type, list_type, tuple_type, string_type, class_type, int32_type, bool_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F, InfoPanel, Entity__get_EntityType, Entity__get_Id, EntityType__ToProperString, EntityType__ToProperPluralString, EntityType__get_DomainEntity, Entity, Entity_$reflection } from "../ClientTypes.fs.js";
import { filter as filter_1, mapIndexed, append, ofArray, map, singleton, empty, length } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { FetchError_$reflection } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { many, count as count_2 } from "../Api/Modules.fs.js";
import { many as many_1, count as count_3 } from "../Api/Areas.fs.js";
import { many as many_2, count as count_4 } from "../Api/Locations.fs.js";
import { many as many_3, count as count_5 } from "../Api/ProductionUnits.fs.js";
import { many as many_4, count as count_6 } from "../Api/Systems.fs.js";
import { many as many_5, count as count_7 } from "../Api/Subsystems.fs.js";
import { many as many_6, count as count_8 } from "../Api/Tags.fs.js";
import { many as many_7, count as count_9 } from "../Api/Documents.fs.js";
import { many as many_8, count as count_10 } from "../Api/Activities.fs.js";
import { many as many_9, count as count_11 } from "../Api/Facilities.fs.js";
import { Result_Map } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { equals, uncurry2, createObj, int32ToString } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Action_Category } from "../DomainEvents.fs.js";
import { Cmd_none, Cmd_OfPromise_perform } from "../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { System_Int32__Int32_ToLocaleString, Thoth_Fetch_FetchError__FetchError_get_Message } from "../Prelude.fs.js";
import { some } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { Fa_ISize, Fa_IconOption, Fa_i } from "../fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { empty as empty_1, singleton as singleton_1, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { join, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { fromString } from "../hooks/../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { toString } from "../hooks/../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Auto_generateBoxedEncoder_437914C6 } from "../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { useFeliz_React__React_useInfoPanel_Static, useFeliz_React__React_useTypedParams_Static } from "../hooks/UseRouter.fs.js";
import { EPM_App_EntityType__EntityType_ApiParams_180030EC } from "../Api/SearchParams.fs.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/./UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Feliz.UseElmish.2.5.0/../Fable.Elmish.4.2.0/program.fs.js";
import { useFeliz_React__React_useInView_Static_13EC530 } from "../hooks/UseInView.fs.js";
import { SearchResult } from "./SearchResult.fs.js";
import { Export } from "../Modals/Tag.fs.js";
import { Export as Export_1 } from "../Modals/Activity.fs.js";
import { filters as filters_1 } from "./Filters.fs.js";
import { op_PlusPlus } from "../fable_modules/Feliz.Bulma.3.0.0/Operators.fs.js";
import { defaultOf } from "../fable_modules/Feliz.2.9.0/../Feliz.Router.4.0.0/../fable-library-js.4.24.0/Util.js";
import "./Search.scss";


class State extends Record {
    constructor(IsLoading, IsTotalLoading, Total, ProjectId, EntityType, Filters, Data) {
        super();
        this.IsLoading = IsLoading;
        this.IsTotalLoading = IsTotalLoading;
        this.Total = (Total | 0);
        this.ProjectId = ProjectId;
        this.EntityType = EntityType;
        this.Filters = Filters;
        this.Data = Data;
    }
}

function State_$reflection() {
    return record_type("EPM.App.Search.SearchPanel.State", [], State, () => [["IsLoading", bool_type], ["IsTotalLoading", bool_type], ["Total", int32_type], ["ProjectId", class_type("System.Guid")], ["EntityType", string_type], ["Filters", list_type(tuple_type(string_type, string_type))], ["Data", list_type(Entity_$reflection())]]);
}

function State__get_HasMore(this$) {
    return this$.Total > length(this$.Data);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadFirstPage", "LoadNextPage", "FirstPageLoaded", "PageLoaded", "LoadError"];
    }
}

function Msg_$reflection() {
    return union_type("EPM.App.Search.SearchPanel.Msg", [], Msg, () => [[["filters", list_type(tuple_type(string_type, string_type))]], [], [["Item1", int32_type], ["Item2", list_type(Entity_$reflection())]], [["Item", list_type(Entity_$reflection())]], [["Item", FetchError_$reflection()]]]);
}

function init(projectId, entityType, filters) {
    return [new State(false, false, 0, projectId, entityType, filters, empty()), singleton((dispatch) => {
        dispatch(new Msg(0, [filters]));
    })];
}

function loadCount(projectId, entityType, filter) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((entityType === "module") ? count_2(projectId, filter) : ((entityType === "area") ? count_3(projectId, filter) : ((entityType === "location") ? count_4(projectId, filter) : ((entityType === "productionUnit") ? count_5(projectId, filter) : ((entityType === "system") ? count_6(projectId, filter) : ((entityType === "subsystem") ? count_7(projectId, filter) : ((entityType === "tag") ? count_8(projectId, filter) : ((entityType === "document") ? count_9(projectId, filter) : ((entityType === "scopeOfWork") ? count_10(projectId, filter) : ((entityType === "activity") ? count_10(projectId, filter) : ((entityType === "certification") ? count_10(projectId, filter) : ((entityType === "punchList") ? count_10(projectId, filter) : ((entityType === "documentTracking") ? count_10(projectId, filter) : ((entityType === "preservation") ? count_10(projectId, filter) : ((entityType === "nonConformanceReport") ? count_10(projectId, filter) : ((entityType === "technicalQuery") ? count_10(projectId, filter) : count_11(projectId, filter))))))))))))))))).then((_arg) => (Promise.resolve(_arg))))));
}

function mapPageResult(successMap, resultPromise) {
    return resultPromise.then((result) => Result_Map((list) => map(successMap, list), result));
}

function loadData(projectId, offset, entityType, filter) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        const apiParams = ofArray([["fetch", int32ToString(30)], ["offset", int32ToString(offset)]]);
        return ((entityType === "module") ? mapPageResult((Item_1) => (new Entity(1, [Item_1])), many(projectId, apiParams, filter)) : ((entityType === "area") ? mapPageResult((Item_2) => (new Entity(2, [Item_2])), many_1(projectId, apiParams, filter)) : ((entityType === "location") ? mapPageResult((Item_3) => (new Entity(3, [Item_3])), many_2(projectId, apiParams, filter)) : ((entityType === "productionUnit") ? mapPageResult((Item_4) => (new Entity(4, [Item_4])), many_3(projectId, apiParams, filter)) : ((entityType === "system") ? mapPageResult((Item_5) => (new Entity(5, [Item_5])), many_4(projectId, apiParams, filter)) : ((entityType === "subsystem") ? mapPageResult((Item_6) => (new Entity(6, [Item_6])), many_5(projectId, apiParams, filter)) : ((entityType === "tag") ? mapPageResult((Item_7) => (new Entity(7, [Item_7])), many_6(projectId, apiParams, filter)) : ((entityType === "document") ? mapPageResult((Item_8) => (new Entity(8, [Item_8])), many_7(projectId, apiParams, filter)) : ((entityType === "scopeOfWork") ? mapPageResult((Item_9) => (new Entity(9, [Item_9])), many_8(projectId, apiParams, filter)) : ((entityType === "activity") ? mapPageResult((a) => (new Entity(10, [new Action_Category(0, []), a])), many_8(projectId, apiParams, filter)) : ((entityType === "certification") ? mapPageResult((a_1) => (new Entity(10, [new Action_Category(1, []), a_1])), many_8(projectId, apiParams, filter)) : ((entityType === "punchList") ? mapPageResult((a_2) => (new Entity(10, [new Action_Category(2, []), a_2])), many_8(projectId, apiParams, filter)) : ((entityType === "documentTracking") ? mapPageResult((a_3) => (new Entity(10, [new Action_Category(3, []), a_3])), many_8(projectId, apiParams, filter)) : ((entityType === "preservation") ? mapPageResult((a_4) => (new Entity(10, [new Action_Category(4, []), a_4])), many_8(projectId, apiParams, filter)) : ((entityType === "technicalQuery") ? mapPageResult((a_5) => (new Entity(10, [new Action_Category(5, []), a_5])), many_8(projectId, apiParams, filter)) : ((entityType === "nonConformanceReport") ? mapPageResult((a_6) => (new Entity(10, [new Action_Category(6, []), a_6])), many_8(projectId, apiParams, filter)) : mapPageResult((Item) => (new Entity(0, [Item])), many_9(projectId, apiParams, filter)))))))))))))))))).then((_arg) => (Promise.resolve(_arg)));
    }));
}

function loadPage(projectId, offset, entityType, filter) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (loadData(projectId, offset, entityType, filter).then((_arg) => {
        const response = _arg;
        return (response.tag === 1) ? (Promise.resolve(new Msg(4, [response.fields[0]]))) : (Promise.resolve(new Msg(3, [response.fields[0]])));
    }))));
}

function loadPageAndCount(projectId, entityType, filters) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => ((Promise.all([loadCount(projectId, entityType, filters), loadData(projectId, 0, entityType, filters)])).then((_arg) => {
        let copyOfStruct, copyOfStruct_1;
        return Promise.resolve((copyOfStruct = _arg[0], (copyOfStruct.tag === 1) ? (new Msg(4, [copyOfStruct.fields[0]])) : ((copyOfStruct_1 = _arg[1], (copyOfStruct_1.tag === 1) ? (new Msg(4, [copyOfStruct_1.fields[0]])) : (new Msg(2, [copyOfStruct.fields[0], copyOfStruct_1.fields[0]]))))));
    }))));
}

function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(true, state.IsTotalLoading, state.Total, state.ProjectId, state.EntityType, state.Filters, state.Data), Cmd_OfPromise_perform(() => loadPage(state.ProjectId, length(state.Data), state.EntityType, state.Filters), undefined, (x_1) => x_1)];
        case 2:
            return [new State(false, false, msg.fields[0], state.ProjectId, state.EntityType, state.Filters, msg.fields[1]), Cmd_none()];
        case 3:
            return [new State(false, state.IsTotalLoading, state.Total, state.ProjectId, state.EntityType, state.Filters, append(state.Data, msg.fields[0])), Cmd_none()];
        case 4: {
            const error = msg.fields[0];
            console.error(some(Thoth_Fetch_FetchError__FetchError_get_Message(error)), error);
            return [new State(false, state.IsTotalLoading, state.Total, state.ProjectId, state.EntityType, state.Filters, state.Data), Cmd_none()];
        }
        default: {
            const filters = msg.fields[0];
            return [new State(true, true, 0, state.ProjectId, state.EntityType, filters, empty()), Cmd_OfPromise_perform(() => loadPageAndCount(state.ProjectId, state.EntityType, filters), undefined, (x) => x)];
        }
    }
}

function resultToggle(isOpen, onClick) {
    let elems;
    return createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "is-medium"], ["className", "has-text-white"], ["className", "is-hidden-mobile"], ["onClick", onClick], (elems = [Fa_i(toList(delay(() => append_1(singleton_1(new Fa_IconOption(15, ["toggle"])), delay(() => append_1(isOpen ? singleton_1(new Fa_IconOption(11, ["fas fa-chevron-left"])) : singleton_1(new Fa_IconOption(11, ["fas fa-chevron-right"])), delay(() => singleton_1(new Fa_IconOption(0, [new Fa_ISize(2, [])])))))))), [])], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
}

function filterToggle(isOpen, onClick) {
    let elems;
    return createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "toggle"], ["className", "is-hidden-mobile"], ["onClick", onClick], (elems = [Fa_i(toList(delay(() => append_1(singleton_1(new Fa_IconOption(11, ["fas fa-filter"])), delay(() => append_1(singleton_1(new Fa_IconOption(0, [new Fa_ISize(2, [])])), delay(() => (isOpen ? singleton_1(new Fa_IconOption(5, [])) : empty_1()))))))), [])], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
}

function SearchResults(props) {
    let patternInput_1;
    const patternInput = reactApi.useState(() => {
        const existingValue = window.localStorage.getItem("searchResults.showDetail");
        if (isNullOrWhiteSpace(existingValue)) {
            return true;
        }
        else {
            const result = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(bool_type, undefined, undefined)), existingValue);
            if (result.tag === 1) {
                console.error(some(`Unable to get ${"searchResults.showDetail"} from local storage`), result.fields[0]);
                return true;
            }
            else {
                return result.fields[0];
            }
        }
    });
    patternInput_1 = [patternInput[0], (value_1) => {
        const json = toString(4, Auto_generateBoxedEncoder_437914C6(bool_type, undefined, undefined, undefined)(value_1));
        window.localStorage.setItem("searchResults.showDetail", json);
        patternInput[1](value_1);
    }];
    const showDetails = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const setDownload = patternInput_2[1];
    let canDownload;
    const matchValue = EntityType__get_DomainEntity(props.entityType);
    switch (matchValue.tag) {
        case 0:
        case 5: {
            canDownload = true;
            break;
        }
        default:
            canDownload = false;
    }
    const typedParams = useFeliz_React__React_useTypedParams_Static();
    let filters;
    const dependencies_1 = [typedParams];
    filters = reactApi.useMemo(() => EPM_App_EntityType__EntityType_ApiParams_180030EC(props.entityType, typedParams), dependencies_1);
    let patternInput_3;
    const init_1 = init(props.projectId, props.entityType, filters);
    patternInput_3 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init_1, update, (_arg, _arg_1) => {
    }), undefined, [props.projectId, props.entityType]);
    const state_1 = patternInput_3[0];
    const dispatch = patternInput_3[1];
    const patternInput_4 = useFeliz_React__React_useInView_Static_13EC530(undefined, undefined, undefined);
    const visibility = patternInput_4[1];
    const infoPanelOpt = useFeliz_React__React_useInfoPanel_Static();
    const dependencies_4 = [visibility, state_1.IsLoading, State__get_HasMore(state_1)];
    reactApi.useEffect(() => {
        switch (visibility) {
            case "partial":
            case "full": {
                if ((!state_1.IsLoading && State__get_HasMore(state_1)) && (length(state_1.Data) > 0)) {
                    dispatch(new Msg(1, []));
                }
                break;
            }
            default:
                undefined;
        }
    }, dependencies_4);
    const dependencies_6 = [filters];
    reactApi.useEffect(() => {
        if (!equals(filters, state_1.Filters)) {
            dispatch(new Msg(0, [filters]));
        }
    }, dependencies_6);
    const xs_16 = toList(delay(() => append_1(singleton_1(createElement("div", createObj(toList(delay(() => append_1(singleton_1(["key", "results"]), delay(() => append_1(showDetails ? singleton_1(["className", join(" ", ["search-results-content", "detailed"])]) : singleton_1(["className", "search-results-content"]), delay(() => append_1(!props.isOpen ? singleton_1(["className", "is-hidden-tablet"]) : empty_1(), delay(() => {
        let elems_6, elems_4, elems_5;
        return singleton_1((elems_6 = [createElement("header", createObj(ofArray([["className", "search-results-header"], (elems_4 = toList(delay(() => {
            let elems_2;
            return append_1(singleton_1(createElement("div", createObj(ofArray([["className", "header-start"], (elems_2 = toList(delay(() => {
                let elems_1;
                return append_1(props.hasFilter ? singleton_1(createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "filter-panel-toggle"], ["className", "is-hidden-mobile"], ["onClick", props.toggleFilter], (elems_1 = [Fa_i(toList(delay(() => append_1(singleton_1(new Fa_IconOption(11, ["fas fa-filter"])), delay(() => append_1(singleton_1(new Fa_IconOption(0, [new Fa_ISize(2, [])])), delay(() => (props.isFilterOpen ? singleton_1(new Fa_IconOption(5, [])) : empty_1()))))))), [])], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))) : empty_1(), delay(() => append_1(singleton_1(createElement("div", {
                    className: "search-result-heading",
                    children: `${(state_1.Total > 1) ? EntityType__ToProperPluralString(state_1.EntityType) : EntityType__ToProperString(state_1.EntityType)}:`,
                })), delay(() => singleton_1(createElement("div", createObj(toList(delay(() => append_1(singleton_1(["className", "search-result-total"]), delay(() => (state_1.IsTotalLoading ? singleton_1(["children", "..."]) : singleton_1(["children", System_Int32__Int32_ToLocaleString(state_1.Total)])))))))))))));
            })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                let elems_3;
                return append_1(singleton_1(createElement("div", createObj(ofArray([["className", join(" ", ["description-toggle", "pretty", "p-switch", "p-fill"])], (elems_3 = [createElement("input", {
                    type: "checkbox",
                    defaultChecked: showDetails,
                    onClick: (_arg_2) => {
                        patternInput_1[1](!showDetails);
                    },
                }), createElement("div", {
                    className: "state",
                    children: createElement("label", {}),
                })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => append_1(canDownload ? singleton_1(createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "is-clickable"], ["title", "Download CSV"], ["children", Fa_i(singleton(new Fa_IconOption(11, ["fas fa-download"])), [])], ["onClick", (_arg_3) => {
                    setDownload(EntityType__get_DomainEntity(props.entityType));
                }]]))))) : empty_1(), delay(() => singleton_1(resultToggle(props.isOpen, props.toggleOpen))))));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("div", createObj(ofArray([["className", "search-results-body"], (elems_5 = toList(delay(() => append_1(mapIndexed((i, entity) => {
            let number, key_35;
            return createElement(SearchResult, (number = ((i + 1) | 0), (key_35 = Entity__get_Id(entity), {
                entity: entity,
                highlight: equals(infoPanelOpt, new InfoPanel(1, [Entity__get_Id(entity), EntityType__get_DomainEntity(Entity__get_EntityType(entity))])),
                key: key_35,
                number: number,
                projectId: props.projectId,
                showDetail: showDetails,
            })));
        }, state_1.Data), delay(() => {
            let show;
            return singleton_1((show = (State__get_HasMore(state_1) ? true : state_1.IsLoading), createElement("span", createObj(Helpers_combineClasses("icon", toList(delay(() => append_1(singleton_1(["ref", patternInput_4[0]]), delay(() => append_1(!show ? singleton_1(["className", "is-hidden"]) : empty_1(), delay(() => append_1(singleton_1(["className", "loading-spinner"]), delay(() => append_1(singleton_1(["className", "is-large"]), delay(() => {
                let elems;
                return singleton_1((elems = [Fa_i(ofArray([new Fa_IconOption(11, ["fas fa-spinner"]), new Fa_IconOption(12, []), new Fa_IconOption(0, [new Fa_ISize(4, [])])]), [])], ["children", reactApi.Children.toArray(Array.from(elems))]));
            })))))))))))))));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))]));
    }))))))))))), delay(() => {
        const matchValue_1 = patternInput_2[0];
        if (matchValue_1 != null) {
            const matchValue_2 = matchValue_1;
            switch (matchValue_2.tag) {
                case 0:
                    return singleton_1(createElement(Export, {
                        projectId: props.projectId,
                        filters: filters,
                        close: () => {
                            setDownload(undefined);
                        },
                    }));
                case 5:
                    return singleton_1(createElement(Export_1, {
                        projectId: props.projectId,
                        filters: filters,
                        close: () => {
                            setDownload(undefined);
                        },
                    }));
                default: {
                    return empty_1();
                }
            }
        }
        else {
            return empty_1();
        }
    }))));
    return react.createElement(react.Fragment, {}, ...xs_16);
}

export function Search(props) {
    let patternInput_1;
    const patternInput = reactApi.useState(() => {
        const existingValue = window.localStorage.getItem("searchResults.filtersOpen");
        if (isNullOrWhiteSpace(existingValue)) {
            return true;
        }
        else {
            const result = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(bool_type, undefined, undefined)), existingValue);
            if (result.tag === 1) {
                console.error(some(`Unable to get ${"searchResults.filtersOpen"} from local storage`), result.fields[0]);
                return true;
            }
            else {
                return result.fields[0];
            }
        }
    });
    patternInput_1 = [patternInput[0], (value_1) => {
        const json = toString(4, Auto_generateBoxedEncoder_437914C6(bool_type, undefined, undefined, undefined)(value_1));
        window.localStorage.setItem("searchResults.filtersOpen", json);
        patternInput[1](value_1);
    }];
    const setFilterOpen = patternInput_1[1];
    const filterOpen = patternInput_1[0];
    let patternInput_3;
    const patternInput_2 = reactApi.useState(() => {
        const existingValue_1 = window.localStorage.getItem("searchResults.resultsOpen");
        if (isNullOrWhiteSpace(existingValue_1)) {
            return true;
        }
        else {
            const result_1 = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(bool_type, undefined, undefined)), existingValue_1);
            if (result_1.tag === 1) {
                console.error(some(`Unable to get ${"searchResults.resultsOpen"} from local storage`), result_1.fields[0]);
                return true;
            }
            else {
                return result_1.fields[0];
            }
        }
    });
    patternInput_3 = [patternInput_2[0], (value_1_1) => {
        const json_1 = toString(4, Auto_generateBoxedEncoder_437914C6(bool_type, undefined, undefined, undefined)(value_1_1));
        window.localStorage.setItem("searchResults.resultsOpen", json_1);
        patternInput_2[1](value_1_1);
    }];
    const setResultsOpen = patternInput_3[1];
    const resultsOpen = patternInput_3[0];
    const filters = filters_1(props.projectId, props.entityType);
    const typedParams = useFeliz_React__React_useTypedParams_Static();
    let clearFilters;
    const dependencies_1 = [typedParams];
    clearFilters = reactApi.useCallback((_arg) => {
        Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(filter_1((p) => {
            switch (p.tag) {
                case 1:
                    return true;
                case 4:
                    return true;
                case 0:
                    return true;
                default:
                    return false;
            }
        }, typedParams), true);
    }, dependencies_1);
    const xs_8 = [createElement("div", createObj(Helpers_combineClasses("column", toList(delay(() => append_1(singleton_1(["className", "is-2"]), delay(() => append_1(singleton_1(["className", "filters-container"]), delay(() => append_1(!filterOpen ? singleton_1(["className", "is-hidden-tablet"]) : empty_1(), delay(() => append_1(!props.isVisibleMobileFilter ? singleton_1(["className", "is-hidden-mobile"]) : empty_1(), delay(() => {
        let elems_1;
        return singleton_1((elems_1 = toList(delay(() => {
            let elems;
            return append_1(singleton_1(createElement("span", createObj(ofArray([["onClick", clearFilters], op_PlusPlus(["className", "clear-filter"], ["className", "has-text-white"]), (elems = [createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "is-large"], ["className", "has-text-danger"], ["children", Fa_i(ofArray([new Fa_IconOption(11, ["fas fa-ban"]), new Fa_IconOption(0, [new Fa_ISize(3, [])])]), [])]])))), "Clear Filters"], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                const matchValue = filters;
                return (matchValue == null) ? singleton_1(defaultOf()) : singleton_1(matchValue);
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))]));
    }))))))))))))), createElement("div", createObj(Helpers_combineClasses("column", toList(delay(() => append_1(resultsOpen ? append_1(singleton_1(["className", "is-3"]), delay(() => singleton_1(["className", "is-one-fifth-widescreen"]))) : singleton_1(["className", "is-narrow"]), delay(() => append_1(!props.isVisibleMobileResults ? singleton_1(["className", "is-hidden-mobile"]) : empty_1(), delay(() => {
        let elems_3, elems_2;
        return singleton_1((elems_3 = [createElement("div", createObj(ofArray([["className", "search-results"], (elems_2 = toList(delay(() => append_1(!resultsOpen ? append_1(singleton_1(resultToggle(resultsOpen, (_arg_1) => {
            setResultsOpen(true);
        })), delay(() => singleton_1(filterToggle(filterOpen, (_arg_2) => {
            setFilterOpen(!filterOpen);
        })))) : empty_1(), delay(() => singleton_1(createElement(SearchResults, {
            entityType: props.entityType,
            hasFilter: filters != null,
            isFilterOpen: filterOpen,
            isOpen: resultsOpen,
            projectId: props.projectId,
            toggleFilter: (_arg_4) => {
                setFilterOpen(!filterOpen);
            },
            toggleOpen: (_arg_3) => {
                setResultsOpen(false);
            },
        })))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))]));
    })))))))))];
    return react.createElement(react.Fragment, {}, ...xs_8);
}

